// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_d8-0";
export var headerCellHover = "_d8-1";